import React from "react";
import { useParams } from "react-router-dom";
import "./ProjectDetail.css";
import "../../Home.css";
import Hr from "../../SVGs/Hr";
import SectionHead from "../../Groups/SectionHead";
import bloodhub from "../../SVGs/bloodHub.svg";
import reverbnation from "../../SVGs/reverbNation.svg";
import flappybird from "../../SVGs/flapppyBird.png";
import stickyNote from "../../SVGs/stickyNote.svg";
import NavBar from "../../NavBar";
import visit from "../../SVGs/button.svg";
import figma from "../../SVGs/figma.svg";
import github from "../../SVGs/Github.svg";
import linkedin from "../../SVGs/Linkedin.svg";
import butter1 from "../../SVGs/butteranime1.gif";
import butter2 from "../../SVGs/butteranime2.gif";
import quiz from "../../SVGs/Quiz.svg";
import ui from "../../SVGs/ui.svg";
import ludo from "../../SVGs/ludo.svg";
import resumebuilder from '../../SVGs/resumeBuilder.svg'
import diploma from "../../SVGs/diplomawale.svg";
import "../../Animation.css";

const Projectdetail = () => {
  const { id } = useParams();

  const projectContent = {
    1: {
      title: "BloodHub: UI for Your Blood Needs",
      techImage: stickyNote,
      t2: "About Bloodhub",
      img: bloodhub,
      description:
        "BloodHub is a dedicated platform aimed at connecting blood donors with those in need, making it easier to access life-saving resources in critical times. The platform streamlines the process of finding nearby donors or blood banks and promotes timely assistance by enabling efficient communication channels. BloodHub enhances the blood donation network, empowers communities to save lives, and promotes health awareness. Its features include user registration, donor matching, emergency alerts, and location-based search for nearby donors, making it a comprehensive and reliable resource in medical emergencies.",
      features: [
        "User Registration – Sign up as a donor or requester.",
        "Donor Matching – Connects compatible donors and recipients.",
        "Location-Based Search – Finds nearby donors or blood banks.",
        "Emergency Alerts – Notifies donors of urgent requests.",
        "Request Tracking – Monitors past and active donation requests.",
        "Blood Bank Integration – Links to local blood banks and hospitals.",
        "Awareness Resources – Shares blood donation info and health tips.",
        "Community Sharing – Allows social sharing for wider outreach.",
        "Data Security – Protects user information and privacy.",
      ],
      techStack: [
        "React",
        "Django",
        "Django REST Framework",
        "SSE",
        "Leaflet",
        "Firebase",
        "Bootstrap",
      ],
      socialLinks: [
        {
          platform: github,
          name: "Github",
          url: "https://github.com/ZeeSHANAli321/BloodHub",
        },
        {
          platform: linkedin,
          name: "LinkedIn",
          url: "https://www.linkedin.com/feed/update/urn:li:activity:7235536121525325824/?originTrackingId=KwDnL8lSR0arUOI1GWQQXg%3D%3D",
        },
        {
          platform: figma,
          name: "Figma",
          url: "https://www.figma.com/design/yNSzXtZQDfLAVFyQbRjvxQ/BloodHUB?node-id=0-1&node-type=canvas&t=Vgf4okQ3atsWezmi-0",
        },
      ],
    },
    2: {
      title: "ReverbNation: A Fully Musical Website",
      t2: "About ReverbNation",
      img: reverbnation,
      button: visit,
      techImage: stickyNote,
      link: "https://codewithgaurave.github.io/ReverbNation/",
      description:
        "Reverb Nation is a music band website designed to provide an immersive experience for rock music lovers. Our project features a fully functional music player that allows users to stream the latest tracks seamlessly. With sections for news and events, fan engagement, and detailed band profiles, the site keeps fans updated and connected with the band’s musical journey.",
      features: [
        "Music Player - Enjoy a sleek, built-in audio player to stream our tracks directly from the site.",
        "Song Previews - Listen to full tracks from our latest album and singles with just one click.",
        "News & Events - Stay updated with the latest band news, tour dates, and upcoming performances.",
        "Fan Engagement - Fans can drop comments and share their favorite songs with friends.",
        "Band Profiles - Explore detailed profiles of band members, their musical journey, and inspirations.",
      ],
      techStack: ["HTML", "CSS", "JS", "BOOTSTRAP"],
      socialLinks: [
        {
          platform: github,
          url: "https://github.com/codewithgaurave/ReverbNation",
        },
        {
          platform: linkedin,
          url: "https://www.linkedin.com/feed/update/urn:li:activity:7244172217356316672/?originTrackingId=fPiHeeNoTgClZ0LQWtUVNg%3D%3D",
        },
        {
          platform: figma,
          url: "https://www.figma.com/design/TK9aRdWzXIORnjSNLt1CoD/Something_Gaurav?node-id=0-1&node-type=canvas&t=oG75VmURmu5yL5oz-0",
        },
      ],
    },
    3: {
      title: "FlappyBird: A Game Using ",
      t2: "About FlappyBird",
      img: flappybird,
      techImage: stickyNote,
      description:
        "Flappy Bird is a classic arcade game where players control a bird to navigate through a series of pipes without hitting them. Built using Python, this game challenges your reflexes and timing as you try to achieve the highest score possible. The simple yet addictive gameplay keeps players engaged as they compete for the best scores.",
      features: [
        "Intuitive Controls - Simple tap controls to make the bird flap and soar.",
        "Challenging Obstacles - Navigate through a series of pipes that increase in difficulty.",
        "Score Tracking - Keep track of your high scores and compete with friends.",
        "Colorful Graphics - Bright and engaging visuals to enhance the gaming experience.",
        "Sound Effects - Enjoy immersive sound effects that add to the gameplay atmosphere.",
        "User Registration - Sign up as a donor or requester.",
        "Donor Matching - Connects suitable donors to those in need.",
        "Location-Based Search - Find nearby donors or blood.",
        "Emergency Alerts - Immediate notifications for urgent needs.",
        "Request Tracking - Monitor and manage blood donation requests.",
        "Data Security - Protect user information and privacy.",
      ],
      techStack: ["Python", "PyGame"],
      socialLinks: [
        {
          platform: github,
          url: "https://drive.google.com/drive/folders/1lx6Bc4zjlYEYWu4fplXqqSw9kUjYOkoZ",
        },
      ],
    },
    4: {
      title: "ErrorQuiz: A Fully",
      t2: "About ErrorQuiz",
      img: quiz,
      button: visit,
      techImage: stickyNote,
      link: "https://quizzzybygaurav.netlify.app/",
      description:
        "ErrorQuiz is a MERN-based web application designed as a comprehensive learning and quiz platform for aspiring developers and students. The website combines educational notes with a challenging quiz experience across various programming languages and web development topics. Users can read through detailed notes, take quizzes, and view comprehensive results, all while tracking their progress and achievements. With features like graphical feedback, detailed answer explanations, and downloadable certificates, ErrorQuiz provides a complete interactive learning environment.",
      features: [
        "Educational Notes - Access detailed notes on HTML, CSS, Android, PHP, and more to learn before taking quizzes.",
        "User Authentication - Sign up and log in for a personalized experience and access to quizzes.",
        "Topic-Based Quizzes - Take challenging quizzes on specific topics and programming languages.",
        "Detailed Answer Feedback - Get explanations for each answer to understand concepts more deeply.",
        "Graphical Performance Analysis - View results with charts to identify strengths and areas to improve.",
        "Certificate Download - Download a personalized certificate upon quiz completion as proof of achievement.",
        "Progress Tracking - Track past quiz scores and history to monitor growth over time.",
        "MERN Stack Backend - Built using MongoDB, Express.js, React, and Node.js for a smooth experience.",
        "Downloadable Reports - Save quiz performance and answer analysis as PDFs for offline review.",
      ],
      techStack: ["ReactJs", "MongoDb"],
      socialLinks: [
        {
          platform: github,
          url: "https://github.com/codewithgaurave/Quizzy",
        },
        {
          platform: linkedin,
          url: "https://www.linkedin.com/feed/update/urn:li:activity:7250555817857327104/?originTrackingId=YAo3qgr2T7y67xMzuXcxrQ%3D%3D",
        },
      ],
    },
    5: {
      title: "DiplomaWale: A Blogger Website to Help Diploma student learning.",
      t2: "About DiplomaWale",
      img: diploma,
      button: visit,
      techImage: stickyNote,
      link: "https://www.diplomawale.in/",
      description:
        "Diplomawale is an educational blog created on the Blogger platform, designed to help diploma students, especially those in technical fields like Computer Science & Engineering. The site offers curated notes, guides, and resources to support students in their studies, along with interactive elements like quizzes and practice materials. Through an accessible and user-friendly design, Diplomawale aims to be a go-to resource for students looking to strengthen their understanding and excel in their coursework.",
      features: [
        "Curated Study Notes - Access comprehensive notes on diploma subjects, especially in technical fields.",
        "Interactive Quizzes - Test your knowledge with topic-based quizzes to reinforce learning.",
        "Student Resources - Find guides, tips, and resources tailored for diploma students.",
        "Regular Updates - Stay current with new notes, quizzes, and content updates on various subjects.",
        "User-Friendly Layout - A clean and organized blog interface for easy navigation and reading.",
        "Blogger-Based Platform - Hosted on Blogger, ensuring simplicity and accessibility for all users.",
        "Mobile Compatibility - Optimized for mobile so students can study on-the-go.",
        "Free Access - All content is freely accessible, making it a valuable resource for students.",
        "Engagement Through Comments - Engage with content by leaving comments and sharing insights with peers.",
        "Downloadable Content - Access downloadable materials like PDFs for offline study (if applicable).",
      ],
      techStack: ["CMS", "SEO", "CONTENT WRITING", "TECHNOLOGY EXPLORE"],
      socialLinks: [
        {
          platform: linkedin,
          url: "https://www.linkedin.com/in/gaurav-gupta-3a1256286/details/projects/",
        },
      ],
    },
    6: {
      title:
        "React UI: Its a simple ui using react for learning react concepts.",
      t2: "About DiplomaWale",
      img: ui,
      button: visit,
      techImage: stickyNote,
      link: "https://reatuigaurav.netlify.app/",
      description:
        "The Interactive Product Showcase is a React-based design project that provides an engaging experience to display product details dynamically. The project focuses solely on React for the front-end, making it ideal for learning and practicing core React concepts without any backend integration. This design project mimics a simplified online store where users can browse products, view detailed information, and add products to a virtual wishlist.",
      features: [
        "Component-Based Structure: Includes reusable components such as ProductList, ProductCard, ProductDetail, and Wishlist to showcase React's component-based design.",
        "State Management with Hooks: Uses useState for handling UI state and useEffect for loading initial product data, providing hands-on experience with React Hooks.",
        "Dynamic Rendering: Conditionally renders the ProductDetail component when a product is clicked, demonstrating conditional rendering and real-time UI updates.",
        "Styling with CSS Modules: Each component has its own CSS module, making styles modular and encapsulated, promoting organized styling in React.",
        "Routing with React Router (Optional): Allows navigation between product list and detail views using React Router, adding client-side routing experience.",
        "Component Communication: Uses props to pass data between components, emphasizing React's data flow and parent-child component communication.",
        "State and Props Drill Down: Highlights the differences between state and props and demonstrates prop drilling to subcomponents.",
        "Responsive Design: Utilizes CSS flexbox and grid layouts to ensure responsive design, making the interface user-friendly on both desktop and mobile devices.",
      ],
      techStack: ["ReactJs", "Tailwind css"],
      socialLinks: [
        {
          platform: github,
          url: "https://github.com/codewithgaurave/reactUi",
        },
        {
          platform: linkedin,
          url: "https://www.linkedin.com/feed/update/urn:li:activity:7255672716291121152/",
        },
      ],
    },
    7: {
      title: "Ludo:Its a ludo game with fully ludo Functional.",
      t2: "About DiplomaWale",
      img: ludo,
      button: visit,
      techImage: stickyNote,
      link: "https://codewithgaurave.github.io/ludobygaurave/",
      description:
        "This Ludo project is an interactive, digital version of the classic board game loved by people of all ages. Built with the goal of providing an enjoyable, easy-to-use interface, it offers a smooth gameplay experience and engaging graphics. The game brings the traditional Ludo experience to the digital world, allowing players to enjoy it with friends, family, or even AI opponents. With its modern features, this Ludo game is designed for accessibility across devices, ensuring players can join the fun anywhere and anytime.",
      features: [
        "Multiplayer mode to play with friends and family online",
        "Single-player mode with AI opponents for solo gameplay",
        "User-friendly interface with intuitive game controls",
        "Vibrant graphics and animations for an immersive experience",
        "Real-time chat feature for players during the game",
        "Customizable player avatars and colors",
        "Save and resume game feature to continue at any time",
        "Leaderboards to track scores and rankings",
        "Compatible across multiple devices, including mobile and desktop",
        "In-game tutorials and rules to help new players",
        "Sound effects and background music to enhance gameplay",
        "Notifications and alerts for player turns and actions",
        "Secure login and profile management for user data protection",
        "Responsive design to adjust to various screen sizes",
      ],
      techStack: ["HTML", "CSS", "JAVASCRIPT"],
      socialLinks: [
        {
          platform: github,
          url: "https://github.com/codewithgaurave/ludobygaurave",
        },
      ],
    },
    8: {
      title: "ResumeBuilder:it's a Innovative website for making Professional Resume..",
      t2: "About DiplomaWale",
      img: resumebuilder,
      button: visit,
      techImage: stickyNote,
      link: "https://gauravresumebuilders.netlify.app/",
      description:
        "The Resume Builder is a user-friendly platform crafted to streamline the process of creating professional resumes, helping users stand out in their career journey. With modern, pre-designed templates and intuitive live editing, users can customize resumes effortlessly. The platform features instant previews to visualize updates in real-time and offers downloadable formats in both PDF and Word, ensuring versatility and convenience. Its responsive design guarantees seamless usability across devices, providing a hassle-free experience for job seekers. Built with a focus on simplicity and functionality, Resume Builder empowers individuals to create standout resumes and elevate their job applications with ease.",
        features: [
          "Pre-designed Templates: A selection of sleek, professional templates for quick and easy customization.",
          "Live Editing: See real-time updates as you build your resume.",
          "Instant Previews: View your resume exactly as it will appear to employers.",
          "Download Options: Export your resume effortlessly in PDF or Word formats.",
          "Responsive Design: A user-friendly interface optimized for all devices—desktop, tablet, and mobile."
        ],        
      techStack: ["React JS"],
      socialLinks: [
        {
          platform: github,
          url: "https://github.com/codewithgaurave/resumeBuilder",
        },
        {
          platform: linkedin,
          url: "https://www.linkedin.com/posts/gaurav-gupta-3a1256286_resumebuilder-careertools-resumetips-activity-7265109299201269760-xP3g?utm_source=share&utm_medium=member_desktop",
        },
      ],
    },
  };

  const project = projectContent[id] || {
    title: "Project Not Found",
    description: "",
  };

  return (
    <>
      <div className="container-fluid">
        <NavBar />
        <img src={butter1} alt="Butterfly 2" className="butterfly butterfly1" />
        <div className="row text-center" id="home" style={{marginTop:'100px'}}>
          <SectionHead text={project.title} />
          <Hr />
        </div>
        <img src={butter2} alt="Butterfly 5" className="butterfly butterfly4" />

        <div className="content container">
          <div className="image-tech-container">
            <img
              src={project.img}
              alt="bloodhub"
              className="ProjectImage img-fluid"
              style={{height:'500px',width:'800px'}}
            />
            <div className="techStack position-relative Text_regular">
              <img
                src={project.techImage}
                alt="stickyNote"
                className="TechImage"
              />
              <p className="tech">
                <span className="Text_bold">TechStack</span> <br />
                {project.techStack.map((tech, index) => (
                  <span key={index} className="tech-item">
                    {tech}
                    {index < project.techStack.length - 1 && ","}{" "}
                  </span>
                ))}
              </p>
              <div className="social-links">
                {project.socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={link.platform}
                      alt={`${link.platform} icon`}
                      className="social-icon"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="description-container container">
            <p className="Des Text_regular">{project.description}</p>
            <SectionHead text={"Key Features: -"} />
            <p className="features Text_regular">
              {project.features.map((feature, index) => (
                <p key={index} className="feature-item">
                  {feature}
                </p>
              ))}
            </p>
            {project.button && (
              <a href={project.link} target="_blank" rel="noopener noreferrer">
                <img src={project.button} alt="Visit Project" />
              </a>
            )}
          </div>
        </div>

        <img src={butter1} alt="Butterfly 2" className="butterfly butterfly2" />
      </div>
    </>
  );
};

export default Projectdetail;
